import { MainService, UnitRead } from './schema'

export const UnitApi = {
  updateUnitRobots: async (data: { id: number; robots: number[] }): Promise<UnitRead> => {
    const { id, robots } = data
    return MainService.mainUnitRobotsCreate(id, { robots: robots })
  },
}
